import { Icon } from "@mui/material";
import Dashboard from "./dashboards/default";
import Accounts from "./Accounts";
import Consumers from "./Consumers";
import ConsumerDetail from "./Consumers/AccountDetail";
import AccountDetail from "./Accounts/AccountDetail";

import Settings from "./settings";
import Saas from "./Saas";
import SaasAccounts from "./Saas/components/accounts";
import IframedApp from "./IframedApp";
import JobDetail from "./Consumers/components/DetailPages/JobDetail";
import EventDetail from "./Consumers/components/DetailPages/EventDetail";
import Changelogs from "./Changelogs"
import ReorderBusiness from "./ReorderBusiness"
import Submissions from "./SUBMISSIONS";
function useRoutes() {
  return [
    {
      type: "collapse",
      name: "Home",
      key: "Home",
      icon: <Icon fontSize="small">home</Icon>,
      route: "/Home",
      component: <Dashboard />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "SAAS",
      key: "saas",
      icon: <Icon fontSize="small">highlight_alt</Icon>,
      route: "/saas",
      component: <Saas />,
      noCollapse: true,
    },
    {
      type: "collapse",
      key: "saas",
      route: "/saas/:product_id/accounts",
      component: <SaasAccounts />,
    },
    {
      type: "collapse",
      name: "Accounts",
      key: "accounts",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/accounts",
      component: <Accounts />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Sorted",
      key: "sorted",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/sorted",
      component: <ReorderBusiness />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Accounts",
      key: "accounts",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/consumers",
      component: <Consumers />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "account-detail",
      key: "account-detail",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/consumer-detail/:id", // Corrected route definition
      component: <ConsumerDetail />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "account-detail",
      key: "account-detail",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/account-detail/:id", // Corrected route definition
      component: <AccountDetail />,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "event-detail",
      key: "event-detail",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/event-detail/:id", // Corrected route definition
      component: <EventDetail />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "changelogs",
      key: "changelogs",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/changelogs", // Corrected route definition
      component: <Changelogs />,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "submissions",
      key: "submissions",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/submissions", // Corrected route definition
      component: <Submissions />,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "job-detail",
      key: "job-detail",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/job-detail/:id", // Corrected route definition
      component: <JobDetail />,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "Settings",
      key: "settings",
      icon: <Icon fontSize="small">settings</Icon>,
      route: "/settings/*",
      component: <Settings />,
      noCollapse: true,
    },
    {
      type: "collapse",
      key: "app_sso", 
      route: "/iframe",
      component: <IframedApp />,
    },
  ];
}

export default useRoutes;
